/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCreditMemo = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M0 2h24v20H0zm2 2v16h20V4z" />
        <path d="M20 9h-5V7h5zm0 4h-4v-2h4zm0 4h-4v-2h4zM8 7V6h2v1h3v2h-3v2h1a3 3 0 1 1 0 6h-1v1H8v-1H5v-2h3v-2H7a3 3 0 1 1 0-6zm0 2H7a1 1 0 0 0 0 2h1zm2 4v2h1a1 1 0 1 0 0-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgCreditMemo as CreditMemo };
